import React from 'react';
import { useState } from 'react';
import { Box, Button, Typography, Grid, Radio, FormControlLabel, RadioGroup } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import selectLang from './selectLang.styles';
import { useTranslation } from '../../hooks/useTranslation';

//Redux
import { useSelector } from 'react-redux';

const SelectLang = ({handleCancel, customDetails}) => {
    const { t, changeLanguage } = useTranslation();
    const languageMap = {
      English: "en",
      हिन्दी: "hi",
      বাংলা: "bn",
      தமிழ்: "ta",
      తెలుగు: "te",
      ಕನ್ನಡ: "kn",
      ଓଡ଼ିଆ: "or",
      सिंधी: "sd",
      मैथिली: "mai",
      बोडो: "brx",
      मराठी: "ma",
      संस्कृतम्: "sa",
      नेपाली: "ne",
      অসমীয়া: "as",
      ગુજરાતી: "gu",
      डोगरी: "doi",
      اردو: "ur",
      कोंकणी: "kok",
      മലയാളം: "ml",
      "ꯃꯤꯇꯩ (Meitei)": "mni",
      ਪੰਜਾਬੀ: "pa",
      کٲشُر: "ks",
    };
    const lang = Object.keys(languageMap);

    const currentLanguage = useSelector((state) => state.translation.currentLanguage || 'en');
    const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);

    const handleProceed = () => {
        changeLanguage(selectedLanguage);
        handleCancel();
    };

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
    };

    return (
        <Box sx={selectLang.root}>
        <Box sx={{...selectLang.boxContainer}}>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item> <Typography sx={{...selectLang.dialogHeading}}>{t('header.dialog.langSelector.title')}</Typography> </Grid>
                <Grid item> <CloseIcon sx={{ ...selectLang.closeIcon }} onClick={handleCancel} /> </Grid>
            </Grid>
            <Typography sx={{...selectLang.dialogSubHeading}}>{t('header.dialog.langSelector.subTitle')}</Typography>
            <RadioGroup
                value={selectedLanguage}
                onChange={handleLanguageChange}
            >
                <Grid container spacing={0} sx={{pb: '0.5rem'}}>
                    {lang.map((language) => (
                        <Grid item xs={12} md={6} key={language} sx={{margin: '0.5rem 0 0 0'}}>
                            <FormControlLabel
                                value={languageMap[language]}
                                control={
                                    <Radio sx={{
                                        ...selectLang.radio,     
                                        '&.Mui-checked': {
                                            color: customDetails?.primaryColor,
                                        }
                                    }} 
                                    />
                                }
                                label={language}
                                sx={{
                                    ...selectLang.selectLang,
                                    backgroundColor: selectedLanguage === languageMap[language] ? '#F5F5F5' : 'transparent',
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </RadioGroup>
        </Box>
        <Box sx={{ ...selectLang.buttonContainer }}>
            <Button onClick={handleProceed}
                sx={{...selectLang.proceedButton(customDetails?.primaryColor)}}
                variant='contained'>
                {t('common.buttons.proceed')}
            </Button>
        </Box>
        </Box>
    )
}

export default SelectLang